/* ==========================================================================
   OVRS — Wishlist drawer
   --------------------------------------------------------------------------
   O tema (Ecomus) ja tem toda a maquina de wishlist: <hdt-wishlist> guarda os
   IDs em localStorage, mantem os botoes sincronizados e dispara
   `theme4:wishlist:update`. O que ele NAO tem e a gaveta — o padrao dele era
   navegar para /search?view=wishlist.

   Este arquivo so faz a ponte: intercepta a navegacao, abre a gaveta e
   preenche com a section `ovrs-wishlist-drawer`.

   Regra que seguimos aqui: NUNCA duplicar o estado da wishlist. Remover e
   limpar sao delegados aos proprios elementos do tema (<hdt-wishlist> e
   <hdt-clear-all>), entao localStorage, contadores do header e coracoes dos
   cards continuam com uma fonte da verdade so. Se duplicassemos, o contador
   do header dessincronizaria da gaveta.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'theme4:wishlist:id';
  var SECTION_ID = 'ovrs-wishlist-drawer';
  var lastCount = null;
  var inFlight = null;

  function root() {
    return document.querySelector('ovrs-wishlist-drawer');
  }

  function drawer() {
    var dialog = document.getElementById('ovrsWishlistDrawer');
    return dialog ? dialog.closest('hdt-drawer') : null;
  }

  /* IDs da wishlist. Modo "app" (EcomRise) publica em #hdt_wishlist_list;
     modo local guarda em localStorage. Lemos os dois para nao quebrar caso o
     Chico ative o app depois. */
  function wishlistIds() {
    var appList = document.getElementById('hdt_wishlist_list');
    if (appList) {
      var t = (appList.textContent || '').trim();
      return t ? t.split(/\s+/) : [];
    }
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? raw.split(',').filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function searchRoot() {
    if (window.themeHDN && themeHDN.routes && themeHDN.routes.search_url) {
      return themeHDN.routes.search_url;
    }
    return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search';
  }

  function sectionUrl(ids) {
    var base = searchRoot() + '/?view=wishlist&section_id=' + SECTION_ID;
    if (!ids.length) return base;
    return (
      base +
      '&type=product&options[unavailable_products]=last&q=' +
      encodeURIComponent('id:' + ids.join(' OR id:'))
    );
  }

  /* ---------------- render ---------------- */

  function setBusy(state) {
    var el = root();
    if (el) el.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  function paintChrome() {
    var el = root();
    if (!el) return;

    var items = el.querySelectorAll('.ovrs-wl__item');
    var count = items.length;
    var empty = el.querySelector('[data-wl-empty]');
    var foot = el.querySelector('[data-wl-foot]');
    var counter = el.querySelector('[data-wl-count-text]');

    if (counter) counter.textContent = count ? '(' + count + ')' : '';
    if (empty) empty.hidden = count > 0;
    if (foot) foot.hidden = count === 0;

    // sem nenhum item comprável, "mover tudo" nao tem o que fazer
    var buyable = el.querySelectorAll('[data-variant-input]').length;
    var moveBtn = el.querySelector('[data-wl-move-all]');
    if (moveBtn) moveBtn.disabled = buyable === 0;
  }

  function message(text, isError) {
    var el = root();
    if (!el) return;
    var box = el.querySelector('[data-wl-msg]');
    if (!box) return;
    box.textContent = text || '';
    box.style.color = isError ? 'rgb(var(--color-error, 220 38 38))' : '';
  }

  function load() {
    var el = root();
    if (!el) return Promise.resolve();

    var ids = wishlistIds();
    var list = el.querySelector('ovrs-wishlist-list');

    if (!ids.length) {
      if (list) list.innerHTML = '';
      paintChrome();
      return Promise.resolve();
    }

    setBusy(true);
    message('');

    // se ja existe uma busca em voo, ela e descartada pelo controlador abaixo
    if (inFlight) inFlight.abort();
    var controller = new AbortController();
    inFlight = controller;

    return fetch(sectionUrl(ids), { signal: controller.signal })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var fresh = parsed.querySelector('ovrs-wishlist-list');
        if (fresh && list) list.innerHTML = fresh.innerHTML;
        paintChrome();
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        console.error('[ovrs-wishlist]', err);
        message('Could not load your wishlist. Please try again.', true);
      })
      .finally(function () {
        if (inFlight === controller) inFlight = null;
        setBusy(false);
      });
  }

  /* ---------------- abrir / fechar ---------------- */

  function open() {
    var d = drawer();
    if (!d || typeof d.open !== 'function') return;
    d.open();
    load();
  }

  function close() {
    var d = drawer();
    if (d && typeof d.close === 'function') d.close();
  }

  function openNativeCart() {
    document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
    var trigger = document.querySelector('a[aria-controls="CartDrawer"]');
    var base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    if (!trigger) { window.location.href = base + 'cart'; return; }
    var done = false, timer;
    var onRender = function () {
      if (done) return;
      done = true;
      clearTimeout(timer);
      document.removeEventListener('cart:drawer:render', onRender);
      trigger.click();
    };
    timer = setTimeout(function () {
      if (done) return;
      done = true;
      document.removeEventListener('cart:drawer:render', onRender);
      window.location.href = base + 'cart';
    }, 2500);
    document.addEventListener('cart:drawer:render', onRender);
  }

  function goToCart() {
    var base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    window.location.href = base + 'cart';
  }

  function openCart() {
    var app = window.SectionStoreCart;
    if (app && typeof app.open === 'function') {
      try {
        var opening = app.open();
        if (opening && typeof opening.catch === 'function') opening.catch(goToCart);
        return;
      } catch (err) { goToCart(); return; }
    }
    openNativeCart();
  }

  /* ---------------- mover tudo para o carrinho ---------------- */

  function moveAllToCart(button) {
    var el = root();
    if (!el) return;

    var inputs = el.querySelectorAll('[data-variant-input]');
    var items = [];
    for (var i = 0; i < inputs.length; i++) {
      var id = inputs[i].value;
      if (id) items.push({ id: Number(id), quantity: 1 });
    }
    if (!items.length) return;

    button.disabled = true;
    message('');

    var cartRoot = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js';

    fetch(cartRoot, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          // /cart/add.js e atomico: em 422 nada foi adicionado
          if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        });
      })
      .then(function () {
        // limpar delegado ao proprio tema, para contador e coracoes irem junto
        var clear = el.querySelector('hdt-clear-all[of-fn="wishlist"]');
        if (clear) clear.click();

        document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));

        close();
        openCart();
      })
      .catch(function (err) {
        console.error('[ovrs-wishlist]', err);
        message(err.message || 'Could not add these items to your cart.', true);
      })
      .finally(function () {
        button.disabled = false;
        paintChrome();
      });
  }

  /* ---------------- listeners ---------------- */

  // 1. Qualquer link para a pagina de wishlist passa a abrir a gaveta.
  //    Cobre header, menu mobile e qualquer outro ponto do tema.
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest ? e.target.closest('a[href*="view=wishlist"]') : null;
      if (!link) return;
      if (!drawer()) return; // sem gaveta, deixa navegar (fallback)
      e.preventDefault();
      e.stopPropagation();
      open();
    },
    true
  );

  // 2. Coracao ja marcado: o tema navegaria para a pagina. Interceptamos na
  //    fase de captura, antes do listener do proprio <hdt-wishlist>.
  document.addEventListener(
    'click',
    function (e) {
      var heart = e.target.closest ? e.target.closest('hdt-wishlist') : null;
      if (!heart) return;
      if (heart.getAttribute('action') !== 'added') return;
      if (heart.hasAttribute('remove-on-page')) return;
      if (!drawer()) return;
      e.preventDefault();
      e.stopPropagation();
      open();
    },
    true
  );

  // 3. O tema avisa toda vez que a lista muda (add, remove, clear).
  //
  // O setTimeout(0) NAO e cosmetico: ao adicionar, o tema dispara este evento
  // ANTES de gravar no localStorage (em add_wis_fn o dispatch vem uma linha
  // acima do setItem). Lendo na hora, veriamos a lista antiga, concluiriamos
  // que nada cresceu e a gaveta nunca abriria. Adiando um tick, a gravacao
  // sincrona ja terminou. (O contador do tema nao sofre disso porque le o
  // array em memoria, nao o localStorage.)
  document.addEventListener('theme4:wishlist:update', function () {
    setTimeout(function () {
      var count = wishlistIds().length;
      var grew = lastCount !== null && count > lastCount;
      lastCount = count;

      var dialog = document.getElementById('ovrsWishlistDrawer');
      var isOpen = dialog && dialog.hasAttribute('open');

      if (grew) {
        open(); // acabou de favoritar: mostra a gaveta
      } else if (isOpen) {
        load(); // aberta: mantem em dia depois de remover/limpar
      }
    }, 0);
  });

  // 4. Acoes dentro da gaveta.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var moveAll = e.target.closest('[data-wl-move-all]');
    if (moveAll) {
      e.preventDefault();
      moveAllToCart(moveAll);
      return;
    }

    var clear = e.target.closest('[data-wl-clear]');
    if (clear) {
      e.preventDefault();
      var el = root();
      var themeClear = el ? el.querySelector('hdt-clear-all[of-fn="wishlist"]') : null;
      if (themeClear) themeClear.click();
      return;
    }
  });

  /* ---------------- boot ---------------- */

  function boot() {
    lastCount = wishlistIds().length;
    paintChrome();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme Editor: a section pode ser recarregada e o boot precisa rodar de novo
  document.addEventListener('shopify:section:load', boot);
})();
